var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoltregLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.227,
    height: 25.056,
    viewBox: "0 0 207.227 25.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39481",
    "data-name": "Group 39481",
    transform: "translate(3.934 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51502",
    "data-name": "Path 51502",
    d: "M88.931,18.459v6.868H85.589V7.29H99.645c4.464,0,6.681,2.166,6.681,5.61s-2.271,5.559-6.868,5.559Zm0-8.177v5.1H99.59c2.06,0,3.234-.935,3.234-2.591,0-1.6-1.149-2.512-3.206-2.512Z",
    transform: "translate(-48.32 -3.781)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51503",
    "data-name": "Path 51503",
    d: "M144.664,25.282c-6.334,0-11.6-3.5-11.6-9.619,0-6.069,5.264-9.595,11.6-9.595s11.6,3.525,11.6,9.595c0,6.117-5.264,9.619-11.6,9.619m0-16.249c-4.917,0-8.1,2.512-8.1,6.63,0,4.141,3.183,6.654,8.1,6.654s8.1-2.513,8.1-6.654c0-4.118-3.179-6.63-8.1-6.63",
    transform: "translate(-72.943 -3.147)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51504",
    "data-name": "Path 51504",
    d: "M195.319,21.988H209.64v3.339H191.977V7.289h3.342Z",
    transform: "translate(-103.494 -3.78)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51505",
    "data-name": "Path 51505",
    d: "M244.7,10.414h-7.83V25.327h-3.339V10.414h-7.8V7.289H244.7Z",
    transform: "translate(-120.996 -3.78)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51506",
    "data-name": "Path 51506",
    d: "M297.729,25.327h-4.651l-5.637-6.868h-7.055v6.868h-3.339V7.29H291.1c4.461,0,6.678,2.166,6.678,5.61,0,3.315-2.35,5.24-6.117,5.532ZM280.385,10.282v5.1h10.288c2.3,0,3.608-.88,3.608-2.591,0-1.6-1.149-2.512-3.206-2.512Z",
    transform: "translate(-147.611 -3.781)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51507",
    "data-name": "Path 51507",
    d: "M355.408,10.149H339.75V14.61h13.869V17.5H339.75v4.7h16v3.128H336.408V7.289h19Z",
    transform: "translate(-178.396 -3.78)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51508",
    "data-name": "Path 51508",
    d: "M405.774,11.467a16.161,16.161,0,0,0-8.816-2.434c-4.491,0-7.643,2.512-7.643,6.63,0,4.141,2.964,6.654,7.616,6.654,3.074,0,5.852-.643,6.9-1.551V17.958h-5.212V15.153h8.551V22.9c-1.418,1.071-4.839,2.38-10.476,2.38-6.039,0-10.8-3.5-10.8-9.619,0-6.069,5.076-9.6,11.064-9.6,4.729,0,9.031,1.469,10.394,2.485Z",
    transform: "translate(-204.059 -3.147)",
    fill: "#0a3940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51509",
    "data-name": "Path 51509",
    d: "M12.53,0V1.457c0,.062,0,.127,0,.193a11.4,11.4,0,0,1-.655,3.208,11.556,11.556,0,0,1-4.194,5.524,11.366,11.366,0,0,1-2.328,1.277,11.426,11.426,0,0,1-4.088.859l-1.26,0v-.041c0-.278.02-.548.037-.822a12.009,12.009,0,0,1,.147-1.277A12.544,12.544,0,0,1,12.505,0Z",
    transform: "translate(-3.934 0)",
    fill: "#734dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51510",
    "data-name": "Path 51510",
    d: "M12.526,36.893A11.607,11.607,0,0,0,.982,26c-.331,0-.655,0-.982,0,0,.412.026.878.066,1.28A12.528,12.528,0,0,0,12.505,38.542h.025V37.089c0-.065,0-.131,0-.2",
    transform: "translate(-3.934 -13.486)",
    fill: "#734dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51511",
    "data-name": "Path 51511",
    d: "M37.568,26.005a11.6,11.6,0,0,0-11.54,10.813v1.723h.016A12.533,12.533,0,0,0,38.483,27.284c.033-.325.052-.654.06-.986V26c-.314.009-.646,0-.975,0",
    transform: "translate(-17.432 -13.485)",
    fill: "#734dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51512",
    "data-name": "Path 51512",
    d: "M38.513,11.659c-.033-.43-.074-.859-.147-1.277h0A12.545,12.545,0,0,0,26.044,0h-.016V1.723a11.507,11.507,0,0,0,.651,3.134,11.593,11.593,0,0,0,4.2,5.525h0A11.339,11.339,0,0,0,33.2,11.659a11.433,11.433,0,0,0,4.088.859l1.252,0v-.2c0-.221-.016-.442-.028-.663",
    transform: "translate(-17.432 0)",
    fill: "#734dff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9809",
    "data-name": "Rectangle 9809",
    width: 207.227,
    height: 25.056,
    transform: "translate(-3.934 0)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoltregLogo);
export default __webpack_public_path__ + "static/media/POLTREG_logo.fb89bda0aeb4a0c850b4ddaad7f735e0.svg";
export { ForwardRef as ReactComponent };